import React, { type FC } from "react";

export const NoData: FC<React.PropsWithChildren> = ({ children }) => (
	<div className="flex h-[150px] items-center justify-center">
		<p className="m-0 max-w-[550px] text-center text-gray-600 text-sm">{children}</p>
	</div>
);
